import React from 'react';
import { SectionTitle } from './SectionTitle';
import { objectionSection } from '../data/salesCopy';
export function ObjectionSection() {
  return <section className="bg-brand-taupe px-4 py-8 text-brand-ivory sm:py-10" data-id="element-165" data-mp="1w0lo0ujc8gjb">
      <div className="mx-auto max-w-3xl" data-id="element-166" data-mp="29zbhm06y7y2x">
        <SectionTitle light data-id="element-167" data-mp="25wydfg7uo889">{objectionSection.heading}</SectionTitle>

        <p className="mt-4 text-center text-[13px] font-medium text-brand-ivory/85 sm:text-[15px]" data-id="element-168" data-mp="25vn8ve6kywg3">
          {objectionSection.intro}
        </p>

        <ul className="mt-3 grid gap-1.5 sm:grid-cols-2" data-id="element-169" data-mp="2ey4xfz9pk169">
          {objectionSection.thoughts.map(t => <li key={t} className="rounded border border-white/20 bg-white/10 px-3 py-1.5 text-[12.5px] font-semibold italic leading-snug text-white sm:text-[13.5px]" data-id="element-170" data-mp="2tmsobs8lzmpv">
              {t}
            </li>)}
        </ul>

        <p className="mt-4 text-center font-serif text-2xl font-extrabold uppercase text-brand-gold sm:text-3xl" data-id="element-171" data-mp="2xo4j0c6cay4x">
          {objectionSection.pivot}
        </p>

        <div className="mt-2 space-y-1.5 text-center text-[13px] font-medium leading-snug text-brand-ivory/90 sm:text-[14.5px]" data-id="element-172" data-mp="1i8j24m0y5jg">
          {objectionSection.body.map(line => <p key={line} data-id="element-173" data-mp="bdtt8q18yc4a">{line}</p>)}
        </div>

        <ol className="mt-4 flex flex-wrap justify-center gap-1.5" data-id="element-174" data-mp="gdoheltn0nln">
          {objectionSection.steps.map((step, i) => <li key={step} className="flex items-center gap-1.5 rounded border border-brand-sand/50 bg-brand-sage/40 px-2.5 py-1 text-[12px] font-bold text-white sm:text-[13px]" data-id="element-175" data-mp="kgbcqwpioqnl" data-mpi={i}>
              <span className="text-brand-gold" data-id="element-176" data-mp="u6nygs92ipvb">{i + 1}.</span>
              {step}
            </li>)}
        </ol>

        <div className="mt-4 space-y-1 text-center text-[13px] font-semibold leading-snug text-white sm:text-[15px]" data-id="element-177" data-mp="z6ikoihwera1">
          {objectionSection.close.map(line => <p key={line} data-id="element-178" data-mp="185xcbl9sx7w4">{line}</p>)}
        </div>
      </div>
    </section>;
}